import styled from 'styled-components';

const Textarea = styled.textarea`
    resize: vertical;
    width: 100%;
    height: ${props => props.height};
`;

export default Textarea;